import { render, staticRenderFns } from "./welcome4.vue?vue&type=template&id=2b498c4f&scoped=true"
import script from "./welcome4.vue?vue&type=script&lang=js"
export * from "./welcome4.vue?vue&type=script&lang=js"
import style0 from "./welcome4.vue?vue&type=style&index=0&id=2b498c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b498c4f",
  null
  
)

export default component.exports